export default __webpack_public_path__ + "static/about-us-security-fedbb3c1ab441b544409a4915aa85aaa.webp";